import { z } from "zod/v4";
import { ValidateInputPhoneNumber } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";

export const senderSchema = z
  .string()
  .nonempty("bookingV3.senderName.error.required")
  .min(3, "bookingV3.senderName.error.min");

export const senderPhoneSchema = z
  .string()
  .nonempty("bookingV3.senderPhone.error.required")
  .min(5, "bookingV3.senderPhone.error.invalid")
  .refine((phone) => {
    return ValidateInputPhoneNumber(phone).success;
  }, {
    message: "bookingV3.senderPhone.error.invalid"
  });

export const senderAddressSchema = z
  .string()
  .nonempty("bookingV3.senderAddress.error.required")
  .min(3, "bookingV3.senderAddress.error.min");

export const senderReceiverSchema = z
  .object({
    addressSender: senderAddressSchema,
    addressReceiver: senderAddressSchema
  })
  .refine(
    (data) =>
      data.addressSender.toLowerCase() !== data.addressReceiver.toLowerCase(),
    {
      message: "bookingV3.senderAddress.error.senderRecipientMismatch",
      path: ["addressSender"]
    }
  );
